import axios from 'axios'

export const canAccessOperationalReport = async () => {
  const token = localStorage.getItem('token')
  if (!token) return false

  const response = await axios.get(
    `${import.meta.env.VITE_API_URL}/request/user/export/incidents/access`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  )

  return response.data?.value?.allowed === true
}
